import { Button, FloatingTooltip, TooltipCore, Text } from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import type { FC } from 'react';

import type { QueuedMessage } from './useChatStream';

type Props = {
  message: QueuedMessage;
  onCancel: (id: string) => void;
};

/** A queued message awaiting submission, distinguished from a sent message. */
export const PendingMessage: FC<Props> = (props) => {
  const { message, onCancel } = props;

  return (
    <div className="flex items-start justify-end gap-1.5">
      <FloatingTooltip placement="left">
        <Button
          aria-label="Cancel queued message"
          className="mt-1 shrink-0"
          variant="quaternary"
          size="xs"
          onClick={() => onCancel(message.id)}
        >
          <UntitledIcon name="x-close" className="size-3" />
        </Button>
        <TooltipCore>Cancel queued message</TooltipCore>
      </FloatingTooltip>

      <div className="rounded-2xl border border-dashed border-purple-300 bg-purple-50 px-4 py-2.5 text-purple-500 whitespace-pre-wrap">
        <Text>{message.content}</Text>
      </div>
    </div>
  );
};
